<script>
import { useAlert, useTrack } from 'dashboard/composables';
import CommissionMetrics from './components/CommissionMetrics.vue';
import ReportFilterSelector from './components/FilterSelector.vue';
import { GROUP_BY_FILTER } from './constants';
import ReportContainer from './ReportContainer.vue';
import { REPORTS_EVENTS } from '../../../../helper/AnalyticsHelper/events';
import ReportHeader from './components/ReportHeader.vue';
import CommissionTable from './components/CommissionTable.vue';
import { mapGetters } from "vuex";

export default {
  name: 'BotReports',
  components: {
    CommissionMetrics,
    ReportHeader,
    ReportFilterSelector,
    ReportContainer,
    CommissionTable,
  },
  data() {
    return {
      from: 0,
      to: 0,
      id: 1,
      groupBy: GROUP_BY_FILTER[1],
      businessHours: false,
      type: 'agent',
      pageNumber: 1,
    };
  },
  computed: {
    ...mapGetters({
      commissionReports: 'commissions/getAll',
      commissionMeta: 'commissions/getMeta',
      uiFlags: 'commissions/getUIFlags',
    }),
    requestPayload() {
      return {
        from: this.from,
        to: this.to,
        id: this.id,
      };
    },
  },
  mounted() {
    this.fetchCommissionReports();
  },
  methods: {
    fetchCommissionReports({ pageNumber } = {}) {
      this.$store.dispatch('commissions/get', {
        page: pageNumber || this.pageNumber,
        from: this.from,
        to: this.to,
        id: this.id,
      });
    },
    onPageChange(pageNumber) {
      this.fetchCommissionReports({ pageNumber });
    },
    getRequestPayload() {
      const { from, to, groupBy, businessHours } = this;

      return {
        from,
        to,
        groupBy: groupBy?.period,
        businessHours,
      };
    },
    onFilterChange({ from, to, groupBy, businessHours, selectedAgents }) {
      this.from = from;
      this.to = to;
      this.id = selectedAgents.map(el => el.id);
      this.groupBy = groupBy;
      this.businessHours = businessHours;
      this.fetchCommissionReports();
    },
  },
};
</script>

<template>
  <ReportHeader :header-title="'Commission Overview'" />
  <div class="flex flex-col gap-4">
    <ReportFilterSelector
      show-agents-filter
      :show-business-hours-switch="false"
      @filter-change="onFilterChange"
    />

    <CommissionMetrics :filters="requestPayload" />
    <CommissionTable
      :commisson-reports="commissionReports"
      :is-loading="uiFlags.isFetching"
      :current-page="Number(commissionMeta.currentPage)"
      :total-count="Number(commissionMeta.count)"
      @page-change="onPageChange"
    />
  </div>
</template>
